export const UPDATE = "session/UPDATE";
export const CLEAR = "session/CLEAR";
